export const TOGGLE_FAVORITES = 'TOGGLE_FAVORITES'

export const toggleFavorites = (fav) => {
    return {
        type: TOGGLE_FAVORITES,
        payload: fav
    }
}

